import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AppInformationService, AuthService, GenesisUnitOfWork, SessionInformationService } from 'app/core/core.module';
import { SharedModule } from 'app/shared/shared.module';
import { DxDataGridComponent } from 'devextreme-angular';
import { alert } from 'devextreme/ui/dialog';
import { BsModalService } from 'ngx-bootstrap/modal';

@Component({
    selector: 'app-sales-by-part',
    templateUrl: './sales-by-part.component.html',
    styleUrls: ['./sales-by-part.component.scss'],
    standalone: false,
})
export class SalesByPartComponent implements OnInit {
    router = inject(Router);
    filter: any;
    orderLineDetails: any[];

    @ViewChild('dataGrid') dataGrid: DxDataGridComponent;
    onExporting = SharedModule.onExporting;

    constructor(private uow: GenesisUnitOfWork, private modalService: BsModalService, public auth: AuthService, private appInfo: AppInformationService, private sessionInfo: SessionInformationService) {}

    async ngOnInit() {
        this.filter = { };
        const filter = this.sessionInfo.getItem('sales-by-part-filter', true);
        if (filter != null) {
            this.filter = filter;
            this.getData();
        }
    }

    async getData() {
        if (!this.filter.startDate || !this.filter.endDate) {
            alert("Please enter a date range", this.appInfo.settings.company);
            return;
        }
        this.appInfo.pleaseWaitShow();
        this.sessionInfo.setItem('sales-by-part-filter', this.filter, true);
        this.orderLineDetails = await this.uow.getDetailsForSalesByPartReport(this.filter.startDate, this.filter.endDate);
        this.appInfo.pleaseWaitHide();
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                template: 'toolbarText',
                location: 'after',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'revert',
                    elementAttr: { title: 'Reset Filters' },
                    onClick: () => {
                        e.component.clearFilter();
                    },
                },
                location: 'after',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'refresh',
                    elementAttr: { title: 'Reset Grid Layout' },
                    onClick: () => {
                        e.component.state({});
                    },
                },
                location: 'after',
            }
        );
    }
}
